import { Component, Input, OnChanges, OnDestroy, OnInit } from '@angular/core';
import { Product } from '@models';
import { CustomLiteratureDocumentListingData } from '@types';

@Component({
  selector: 'ft-regulatory-fund-name-cell-renderer',
  templateUrl: './regulatory-fund-name-cell-renderer.component.html',
  styleUrls: ['./regulatory-fund-name-cell-renderer.component.scss'],
})
export class RegulatoryFundNameCellRendererComponent implements OnChanges {
  @Input() cellRendererData: CustomLiteratureDocumentListingData;
  /**
   * Params
   */
  public data: CustomLiteratureDocumentListingData;
  public fundLink: string;
  public fundName: string;

  ngOnChanges(): void {
    if (this.cellRendererData) {
      this.agInit(this.cellRendererData);
    }
  }

  agInit(params) {
    this.data = params.data;
    // DCE-2192 - if isShareclassLevelRegulatory fund flag come as true from br than concate fund name and shareclass
    if (this?.data?.shareClass.length > 0) {
      const [shareClass] = this?.data?.shareClass;
      this.fundName = this.data.product.fundName;
      if (shareClass !== '-') {
        this.fundName = `${this.fundName} - ${shareClass}`;
      }
      this.fundLink = this.getFundLink();
    } else {
      this.fundName = this.data.product.fundName;
      this.fundLink = this.getFundLink();
    }
  }

  getFundLink(): string {
    if (this.data.shareClass.length === 1 && this.data.shareClass[0] !== '-') {
      return this.data.product.shareClasses.find(
        (data) =>
          data.shareClassName?.trim() === this.data.shareClass[0]?.trim()
      )?.link;
    }
    return this.data.product.shareClasses.find(
      (data) => data.primaryShareClass === true
    )?.link;
  }
}
